import { GalleryItem } from './../models/gallery-item';
import { Injectable } from '@angular/core';
import { Api } from './api/api';
import * as Constants from '../app.constants';
import { Evento } from '../models/evento';
import { FasciaApertura } from '../models/fascia-apertura';
import { DatePipe } from '@angular/common';
import { FavouriteService } from 'src/app/services/favourite.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ElencoEventi } from '../models/elenco-eventi';
import { CacheService } from 'ionic-cache';
import { TTL_EVENTS } from 'src/app/app.constants';
import { TranslateService } from '@ngx-translate/core';
import { Localizzazione } from '../models/localizzazione';
import { environment } from 'src/environments/environment';
import { Image } from '@ks89/angular-modal-gallery';

@Injectable({
  providedIn: 'root'
})
export class EventService {
  constructor(
    private api: Api,
    private favouriteService: FavouriteService,
    private translateService: TranslateService,
    private httpClient: HttpClient,
    private cache: CacheService
  ) {
  }

  estraiDate(obj: Evento) {
    let dataGlobaleInizio: Date;
    let dataGlobaleFine: Date;

    let today = new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate()
    );
    obj.giorniAllEvento = -1;

    if (obj.opening) {
      obj.opening.forEach(element => {
        let dataInizioOpening: Date;
        let dataFineOpening: Date;

        if (element.startDate) {
          dataInizioOpening = new Date(
            element.startDate[0],
            element.startDate[1] - 1,
            element.startDate[2]
          );
          if (
            !dataGlobaleInizio ||
            (dataGlobaleInizio && dataInizioOpening < dataGlobaleInizio)
          ) {
            dataGlobaleInizio = dataInizioOpening;
          }
        }

        if (element.endDate) {
          dataFineOpening = new Date(
            element.endDate[0],
            element.endDate[1] - 1,
            element.endDate[2]
          );
          if (
            !dataGlobaleFine ||
            (dataGlobaleFine && dataFineOpening > dataGlobaleFine)
          ) {
            dataGlobaleFine = dataFineOpening;
          }
        }
        if (today >= dataInizioOpening && today <= dataFineOpening) {
          obj.giorniAllEvento = 0;
        } else if (dataInizioOpening > today) {
          let giorni = this.datediff(today, dataInizioOpening);

          if (
            giorni > 0 &&
            (giorni < obj.giorniAllEvento || obj.giorniAllEvento == -1)
          ) {
            obj.giorniAllEvento = giorni;
          }
        }

        //Mentre itero sui periodo, setto anche la stringa della fascia oraria
        element.periodoLong = this.formatPeriodo(
          dataInizioOpening,
          dataFineOpening,
          'long'
        );

        //Imposto la fascia oraria
        if (element.openingTimes) {
          element.openingTimes.forEach(hours => {
            if (hours.startHour && hours.endHour) {
              hours.fasciaOrariaString =
                this.toTime(hours.startHour) + '-' + this.toTime(hours.endHour);
            } else if (hours.startHour && !hours.endHour) {
              hours.fasciaOrariaString = this.toTime(hours.startHour);
            }
          });
        }
      });

      //Salvo la data iniziale e finale dell'evento
      obj.dataInizioEvento = dataGlobaleInizio;
      obj.dataFineEvento = dataGlobaleFine;

      //Salvo le stringhe per il periodo intero
      obj.periodoEventoShort = this.formatPeriodo(
        dataGlobaleInizio,
        dataGlobaleFine,
        'short'
      );
      obj.periodoEventoLong = this.formatPeriodo(
        dataGlobaleInizio,
        dataGlobaleFine,
        'long'
      );

      //Salvo il tipo di periodo dell'evento
      if (dataGlobaleInizio) {
        if (dataGlobaleFine) {
          if (
            dataGlobaleInizio.getFullYear() === dataGlobaleFine.getFullYear() &&
            dataGlobaleInizio.getMonth() === dataGlobaleFine.getMonth() &&
            dataGlobaleInizio.getDate() === dataGlobaleFine.getDate()
          ) {
            obj.periodoDurataEvento =
              Constants.TYPE_EVENTS_PERIOD.PERIOD_SAME_DATE;
          } else if (
            dataGlobaleInizio.getFullYear() === dataGlobaleFine.getFullYear() &&
            dataGlobaleInizio.getMonth() === dataGlobaleFine.getMonth()
          ) {
            obj.periodoDurataEvento =
              Constants.TYPE_EVENTS_PERIOD.PERIOD_SAME_MONTH;
          } else if (
            dataGlobaleInizio.getFullYear() === dataGlobaleFine.getFullYear()
          ) {
            obj.periodoDurataEvento =
              Constants.TYPE_EVENTS_PERIOD.PERIOD_DIFFERENT_MONTH_SAME_YEAR;
          } else {
            obj.periodoDurataEvento =
              Constants.TYPE_EVENTS_PERIOD.PERIOD_DIFFERENT_YEAR;
          }
        } else {
          obj.periodoDurataEvento =
            Constants.TYPE_EVENTS_PERIOD.PERIOD_ONLY_START_DATE;
        }
      } else {
        obj.periodoDurataEvento = Constants.TYPE_EVENTS_PERIOD.PERIOD_ERROR;
      }
    }
  }

  toTime(date: Date) {
    const hours = '0' + date[0];
    const minutes = '0' + date[1];
    const time =
      hours.substr(hours.length - 2) + ':' + minutes.substr(minutes.length - 2);
    return time;
  }

  datediff(first: Date, second: Date) {
    // Take the difference between the dates and divide by milliseconds per day.
    // Round to nearest whole number to deal with DST.
    return Math.round(
      (second.getTime() - first.getTime()) / (1000 * 60 * 60 * 24)
    );
  }

  formatPeriodo(dataInizio: Date, dataFine: Date, mode: string) {
    const datePipe = new DatePipe(this.translateService.currentLang);

    let dataEvento;
    let pattern = 'dd MMMM';
    let patternWithYear = 'dd MMMM yyyy';
    if (mode === 'short') {
      pattern = 'dd MMM';
      patternWithYear = 'dd/MM/yy';
    }

    if (
      dataInizio != null &&
      dataFine != null &&
      dataInizio.getFullYear() === dataFine.getFullYear() &&
      dataInizio.getMonth() === dataFine.getMonth() &&
      dataInizio.getDate() === dataFine.getDate()
    ) {
      dataEvento = `${datePipe.transform(dataInizio, pattern)}`;
    } else if (
      dataInizio != null &&
      dataFine != null &&
      dataInizio.getFullYear() === dataFine.getFullYear() &&
      dataInizio.getMonth() === dataFine.getMonth()
    ) {
      dataEvento = `${datePipe.transform(
        dataInizio,
        pattern
      )} - ${datePipe.transform(dataFine, pattern)}`;
    } else if (
      dataInizio != null &&
      dataFine != null &&
      !(dataInizio.getFullYear() === dataFine.getFullYear()) &&
      dataInizio.getMonth() === dataFine.getMonth()
    ) {
      dataEvento = `${datePipe.transform(
        dataInizio,
        patternWithYear
      )} - ${datePipe.transform(dataFine, patternWithYear)}`;
    } else if (dataInizio != null && dataFine == null) {
      dataEvento = `${datePipe.transform(dataInizio, pattern)}`;
    } else {
      dataEvento = `${datePipe.transform(
        dataInizio,
        pattern
      )} - ${datePipe.transform(dataFine, pattern)}`;
    }
    return dataEvento;
  }

  formatIndirizzoEsteso(evento: Evento) {
    let indirizzoEsteso = ``;
    if (evento) {

      let indirizzo = '';
      let comune = '';
      let provincia = '';

      if (evento.address) {
        indirizzo = indirizzo.concat(evento.address);
        if (evento.nhouse && evento.nhouse != '0') {
          indirizzo = indirizzo.concat(`, ${evento.nhouse}`);
        }
      }
      if (evento.city) {
        comune = evento.city;
      }
      if (evento.province) {
        provincia = provincia.concat(` (`, evento.province, `)`);
      }
      
      switch (Constants.MODE_APP_LOCALE) {
        case Constants.MODE_APP_LOCALE_CITY_ADDRESS:
          indirizzoEsteso = indirizzo.concat(` - `, comune, ``);
          break;
        case Constants.MODE_APP_LOCALE_CITY:
          indirizzoEsteso = comune;
          break;
        case Constants.MODE_APP_LOCALE_ADDRESS:
          indirizzoEsteso = indirizzo;
          break;      
        default:
          break;
      }
    }

    return indirizzoEsteso;
  }

  loadFromCache(path) {

    this.cache.enableCache(false);
    this.cache.setDefaultTTL(60 * TTL_EVENTS);


    let groupKey = "events";
    let ttl = 60 * TTL_EVENTS;

    let headers = new HttpHeaders({
      'Accept-Language': this.translateService.currentLang
    });
    let options = { headers: headers };

    let cacheKey = path + '&' + this.translateService.currentLang;
    let request = this.httpClient.get(path, options);
    return this.cache.loadFromObservable(cacheKey, request, groupKey, ttl);
  }

  getEvents(page?, size?) {
    return new Promise((resolve, reject) => {

     
      const path = `${Constants.API_BASE_URL}${Constants.BASE_EVENT_URL}${
        Constants.LIST_EVENT_URL
      }?landId=${environment.api.tenantId}&page=${page}&size=${size}`;

      this.loadFromCache(path).subscribe(
        async (res: any) => {
          const elencoEventi = new ElencoEventi();
          elencoEventi.elenco = res.content;
          elencoEventi.page = res.number;
          elencoEventi.size = res.size;
          elencoEventi.maximumPages = res.totalPages;
          elencoEventi.totalElements = res.totalElements;

          const obj = elencoEventi.elenco;

          for (const key in obj) {
            if (obj[key]) {
              this.estraiDate(obj[key]);

              obj[key].indirizzoEsteso = this.formatIndirizzoEsteso(obj[key]);

              //Recupero i favourite dallo storage
              obj[key].isFavourite = await this.favouriteService.isFavorite(
                obj[key].id,
                obj[key].typeElement.key
              );
            }
          }

          resolve(elencoEventi);
        },
        err => {
          console.error('Lista vuota');

          reject(new ElencoEventi());
        }
      );
    });
  }

  searchNearPosition( position: Localizzazione,distance: number, page:number, size: number, idsToExclude ) {
    return this.searchEvents(
      null,
      null,
      null,
      position,
      distance,
      idsToExclude,
      null,
      page,
      size,
      null,
      null,
      null,
      null
    );
  }

  searchEvents(
    cityIds?: string,
    categoriesKey?: string,
    tagsKey?: string,
    localizzazione?: Localizzazione,
    distanza?: number,
    idsToExclude?: string,
    title?: string,
    page?: number,
    size?: number,
    sortBy?: string,
    sortDirection?: string,
    dateFrom?: Date,
    dateTo?: Date
  ) {
    return new Promise((resolve, reject) => {
      const datePipe = new DatePipe(this.translateService.currentLang);

      let path = `${Constants.API_BASE_URL}${Constants.BASE_EVENT_URL}${
        Constants.LIST_EVENT_URL
      }?landId=${environment.api.tenantId}`;

      if(cityIds){
        path = path.concat(`&cityIds=${cityIds}`);
      }
      if (categoriesKey) {
        path = path.concat(`&categoriesKey=${categoriesKey}`);
      }
       if (tagsKey) {
        path = path.concat(`&tagsKey=${tagsKey}`);
      }
      if (idsToExclude) {
        path = path.concat(`&idsToExclude=${idsToExclude}`);
      }
      if (title) {
        path = path.concat(`&title=${title}`);
      }

      if (page) {
        path = path.concat(`&page=${page}`);
      }
      if (size) {
        path = path.concat(`&size=${size}`);
      }

      if (sortBy) {
        path = path.concat(`&sortBy=${sortBy}`);
      }
      if (sortDirection) {
        path = path.concat(`&sortDirection=${sortDirection}`);
      }

      if (dateFrom) {
        path = path.concat(
          `&dateFrom=${datePipe.transform(dateFrom, 'yyyy-MM-dd')}`
        );
      }
      if (dateTo) {
        path = path.concat(
          `&dateTo=${datePipe.transform(dateTo, 'yyyy-MM-dd')}`
        );
      }

      if (localizzazione && localizzazione.latitude) {
        path = path.concat(`&latitude=${localizzazione.latitude}`);
      }
      if (localizzazione && localizzazione.longitude) {
        path = path.concat(`&longitude=${localizzazione.longitude}`);
      }
      if (distanza) {
        path = path.concat(`&distance=${distanza}`);
      }

      this.loadFromCache(path).subscribe(
        async (res: any) => {
          console.log(res);
          if ( res ) {
            const elencoEventi = new ElencoEventi();
            elencoEventi.elenco = res.content;
            elencoEventi.page = res.number;
            elencoEventi.size = res.size;
            elencoEventi.maximumPages = res.totalPages;
            elencoEventi.totalElements = res.totalElements;
  
            const obj = elencoEventi.elenco;
            for (const key in obj) {
              if (obj[key]) {
                obj[key].indirizzoEsteso = this.formatIndirizzoEsteso(obj[key]);
  
                this.estraiDate(obj[key]);
  
                //Recupero i favourite dallo storage
                obj[key].isFavourite = await this.favouriteService.isFavorite(
                  obj[key].id,
                  obj[key].typeElement.key
                );
              }
            }
            resolve(elencoEventi);

          } else {
            reject(new ElencoEventi());

          }


        },
        err => {
          console.error('Lista vuota');

          reject(new ElencoEventi());
        }
      );
    });
  }

  //TODO
  /** Questo servizio prenderà in ingresso
   * le categorie delle evento, per cercare eventi simili
   * la localizzazione dell'evento, per cercare eventi vicini
   * la distanza
   * l'id dell'evento per escluderlo dalla lista
   */

  getOtherEventsByCategories(
    evento: Evento,
    nearLocation: Localizzazione,
    nearDistance: number
  ) {
    let dateFrom: Date = null;
    dateFrom = new Date();
    const dateTo: Date = null;
    let categoriesKeys = '';
    evento.categories.forEach(element => {
      categoriesKeys = categoriesKeys.concat(element.key + ',');
    });

    console.log('getOtherEventsByCategories');

    // tslint:disable-next-line: max-line-length
    return this.searchEvents(
      ``,
      categoriesKeys,
      ``,
      nearLocation,
      nearDistance,
      evento.id,
      ``,
      null,
      null,
      Constants.EVENTS.SORT_BY.STAR_DATE,
      Constants.SORT_DIRECTION.ASC,
      dateFrom,
      dateTo
    );
  }
  getOtherEvents(
    evento: Evento,
    nearLocation: Localizzazione,
    nearDistance: number
  ) {
    let dateFrom: Date = null;
    dateFrom = new Date();
    const dateTo: Date = null;

    // tslint:disable-next-line: max-line-length
    return this.searchEvents(
      ``,
      ``,
      ``,
      nearLocation,
      nearDistance,
      evento.id,
      ``,
      null,
      null,
      Constants.EVENTS.SORT_BY.STAR_DATE,
      Constants.SORT_DIRECTION.ASC,
      dateFrom,
      dateTo
    );
  }
  getEventsByText(
    text: string,
    nearLocation: Localizzazione,
    nearDistance: number
  ) {
    let dateFrom: Date = null;
    dateFrom = new Date();
    const dateTo: Date = null;

    // tslint:disable-next-line: max-line-length
    return this.searchEvents(
      ``,
      ``,
      ``,
      nearLocation,
      nearDistance,
      ``,
      text,
      null,
      null,
      Constants.EVENTS.SORT_BY.STAR_DATE,
      Constants.SORT_DIRECTION.ASC,
      dateFrom,
      dateTo
    );
  }

  getEventById(id: string) {
    const evento = new Evento();
    evento.id = id;
    return this.getEvent(evento);
  }

  getEvent(event: Evento) {
    return new Promise((resolve, reject) => {

      console.log('getEvent ' + event.id);
      const path = `${Constants.API_BASE_URL}${Constants.BASE_EVENT_URL}${
        Constants.LIST_EVENT_URL
      }${event.id}?landId=${environment.api.tenantId}`;
      this.loadFromCache(path).subscribe(
        async (res: any) => {
          //console.log('Recupero Evento');

          if ( res ) {

            let mediaServerLandUrl = `?landId=${environment.api.tenantId}`;
            let mediaServerBaseURL =
              Constants.API_BASE_URL +
              Constants.BASE_MEDIA_URL +
              Constants.MEDIASERVER_DOWNLOAD_URL;


            res.indirizzoEsteso = this.formatIndirizzoEsteso(res);
            this.estraiDate(res);

              /**
               * Recupero la Gallery - Converto Mappa in Array
               */
              res.galleryImages = [];

              if ( res.gallery ) {
                let mapGallery = new Map(Object.entries( res.gallery ));
                mapGallery.forEach( (element:GalleryItem,key) => {
                    
                res.galleryImages.push( new Image(+key,      {
                    img: mediaServerBaseURL + element.image + mediaServerLandUrl,
                    description: element.captionGalleryImg
                  },
                  {
                    img: mediaServerBaseURL + element.thumbnail + mediaServerLandUrl,
                    title: element.captionGalleryImg,
                    alt: element.captionGalleryImg,
                    ariaLabel: element.captionGalleryImg,
                  }) );
                });
              }

  
            //Recupero i favourite dallo storage
            res.isFavourite = await this.favouriteService.isFavorite(
              res.id,
              res.typeElement.key
            );
  
            resolve(res);
          } else {
            console.error('Evento non trovato');
            reject();
          }

        },
        err => {
          console.error('Lista vuota');

          reject(new Evento());
        }
      );
    });
  }
}
